import React, { Component } from 'react'
import Hero from "../commons/Hero";
import { Link } from "react-router-dom";
import Navbar from "../commons/Navbar";



export class Resume extends Component {
  

  render() {
    return (
      <div className="resume">
        <Navbar />

        <Hero 
          heading={
            [
              <p>
              Here's an overview of my professional work.
              <br/>
              In addition some of my feature startup projects
             </p>
             ]}
        />

        <div className="container">
          <div className="content">

          <h2>My Professional Work</h2>

        <p>
          These are some of my projects that have done with clients. I actively maintain both sites,
          and The Practice of Arthur E. Cash is in the process of being completely redesigned to
          give it a modern look and feel.
        </p>

            <div className="projectList">

              <div className="row">

                <div className="entry">

                    <div className="left col-md-6">
                        <img src="assets/img/resume-logo-mouncal.jpg" alt=""/>
                    </div>

                    <div className="right col-md-6">

                      <h3>Mount Calvary <br/> Baptist Church</h3>
                      <p>
                      Was asked by the Senior Pastor of Mount Calvary Baptist Church, to design and implement a website for the church.  ....

                      </p>

                      <div className="btn btn-babyblue">
                          <Link to="/calvary">MORE </Link>
                        </div>

                    </div>

                </div>

                <div className="entry">

                    <div className="left col-md-6">
                        <img src="assets/img/resume-logo-cash.jpg" alt=""/>
                    </div>

                    <div className="right col-md-6">

                        <h3>The Practice <br/> of Arthur E. Cash</h3>
                        <p>
                        Was asked by Mr. Arthur Cash to design and implement a website for his business The Practice of Arthur E. Cash. ....

                        </p>

                        <div className="btn btn-babyblue">
                          <Link to="/arthurorig">MORE </Link>
                        </div>

                    </div>

                </div>

                
              </div>
            </div>

            <h2>My Featured Startup/Side Projects</h2>

            <p>
            These are some of my side projects that I have put together, while learning multiple technologies. These projects give an insight into some of the skills I have learned over time.
            </p>

            <div className="projectList">

                <div className="entry">

                    <div className="left col-md-6">
                        <img src="assets/img/resume-logo-enviro.jpg" alt=""/>
                    </div>

                    <div className="right col-md-6">

                      <h3>Envirogreen <br/> Real Estate</h3>
                      <p>
                      This A very simple, fictional Real Estate site. The front-end is simply HTML/CSS using the BootStrap framework.  ....

                      </p>

                      <h4>Technology Stack Used</h4>

                      <ul>
                        <li>Html</li>
                        <li>Css</li>
                        <li>Laravel</li>
                        <li>JavaScript</li>
                      </ul>

                      <div className="btn btn-babyblue">
                            <Link to="/envirogreen">MORE </Link>
                        </div>

                    </div>

                </div>

                <div className="entry">

                    <div className="left col-md-6">
                        <img src="assets/img/resume-logo-sole.jpg" alt=""/>
                    </div>

                    <div className="right col-md-6">

                      <h3>Social Sole</h3>
                      <p>
                      This is a very simple fictional social media site, built with the MERN stack, based around the love of sneakers  ....

                      </p>

                      <h4>Technology Stack Used</h4>

                      <ul>
                        <li>MongoDB</li>
                        <li>Express.js</li>
                        <li>React.js</li>
                        <li>Node</li>
                      </ul>

                      <div className="btn btn-babyblue">
                            <Link to="/sole">MORE </Link>
                        </div>

                    </div>

                </div>

                <div className="entry">

                    <div className="left col-md-6">
                        <img src="assets/img/resume-logo-univ.jpg" alt=""/>
                    </div>

                    <div className="right col-md-6">

                      <h3>Blueleaf University</h3>
                      <p>
                      This is a very simple, fictional University site that's built with Wordpress, including a custom theme, that's built from scratch  ....

                      </p>

                      <h4>Technology Stack Used</h4>

                      <ul>
                        <li>Html</li>
                        <li>JavaScript</li>
                        <li>PHP</li>
                        <li>WordPress</li>
                      </ul>

                      <div className="btn btn-babyblue">
                            <Link to="/blueleaf">MORE </Link>
                        </div>

                    </div>

                </div>


            </div>

          </div>
        </div>
        
      </div>
    )
  }
}

export default Resume
